// extracted by mini-css-extract-plugin
module.exports = {"stats":"Stats-module--stats--3WeCV","accountTeaserStats":"Stats-module--accountTeaserStats--1cLiJ"};